import TIM from 'tim-js-sdk'
/**
 * 获取url参数
 * @param name
 * @returns {string|null}
 */
export function getQueryString(name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    let r = window.location.search.substr(1).match(reg)
    if (r != null) {
        return decodeURIComponent(r[2])
    }

    return null
}

/**
 * 判断变量是否为空，
 * @param  {[type]}  param 变量
 * @return {Boolean}      为空返回true，否则返回false。
 */
export function isEmpty(param) {
    if(param) {
        var param_type = typeof (param)
        if(param_type == 'object') {
            //要判断的是【对象】或【数组】或【null】等
            if(typeof (param.length) == 'undefined') {
                if(JSON.stringify(param) == '{}') {
                    return true//空值，空对象
                }
            }else if(param.length == 0) {
                return true//空值，空数组
            }
        }else if(param_type == 'string') {
            //如果要过滤空格等字符
            var new_param = param.trim()
            if(new_param.length == 0) {
                //空值，例如:带有空格的字符串" "。
                return true
            }
        }else if(param_type == 'boolean') {
            if(!param) {
                return true
            }
        }else if(param_type== 'number') {
            if(!param) {
                return true
            }
        }
        return false//非空值
    }else{
        //空值,例如：
        //(1)null
        //(2)可能使用了js的内置的名称，例如：var name=[],这个打印类型是字符串类型。
        //(3)空字符串''、""。
        //(4)数字0、00等，如果可以只输入0，则需要另外判断。
        return true
    }
}

export function theme_asset(path) {
    // eslint-disable-next-line no-undef
    return process.env.VUE_APP_URL+'themes/default/assets/'+path
}

export function filterCallingMessage(currentMessageList) {
    currentMessageList.forEach((item) => {
        if (item.callType) {   // 对于自己伪造的消息不需要解析
            return
        }
        if (item.type === TIM.TYPES.MSG_MERGER && item.payload.downloadKey !== '') {
            let promise = window.tim.downloadMergerMessage(item)
            promise.then(function(imResponse) {
                // 下载成功后，SDK会更新 message.payload.messageList 等信息
                item = imResponse
            }).catch(function(imError) {
                // 下载失败
                console.warn('downloadMergerMessage error:', imError)
            })
        }
        if(item.type === TIM.TYPES.MSG_CUSTOM) {
            let payloadData = {}
            try {
                payloadData = JSON.parse(item.payload.data)
            }catch (e) {
                payloadData = {}
            }
            if(payloadData.businessID === 1) {
                if(item.conversationType === TIM.TYPES.CONV_GROUP) {
                    if(payloadData.actionType === 5) {
                        item.nick = payloadData.inviteeList ? payloadData.inviteeList.join(','):item.from
                    }
                    let _text = window.trtcCalling.extractCallingInfoFromMessage(item)
                    let group_text = `${_text}`
                    item.type = TIM.TYPES.MSG_GRP_TIP
                    let customData = {
                        operationType: 256,
                        text: group_text,
                        userIDList: []
                    }
                    item.payload = customData//JSON.stringify(customData)
                }
                if(item.conversationType === TIM.TYPES.CONV_C2C) {
                    let c2c_text = window.trtcCalling.extractCallingInfoFromMessage(item)
                    let customData = {
                        text: c2c_text
                    }
                    item.payload = customData//JSON.stringify(customData)
                }
            }
        }

    })
}

/**
 * 格式化video通话时间
 * @export
 * @param {number} int
 * @returns
 */
function formatInt(int) {
    return int < 10 ? `0${int}` : int
}
export function formatDuration(duration) {
    if (duration < 60) {
        return `00:00:${formatInt(duration)}`
    }
    if (duration < 60 * 60) {
        const min = parseInt(duration / 60)
        const sec = duration - min * 60
        return `00:${formatInt(min)}:${formatInt(sec)}`
    }
    const hour = parseInt(duration / (60 * 60))
    const remainder = duration - hour * (60 * 60)
    const min = parseInt(remainder / 60)
    const sec = remainder - min * 60
    return `${formatInt(hour)}:${formatInt(min)}:${formatInt(sec)}`
}
